import React, { useEffect } from 'react'
import { RiMessage2Line } from "react-icons/ri";
import { useState } from 'react';
import { IoIosArrowRoundForward } from "react-icons/io";
import profil from "../../../../ASSETS/tourisme/Image/close-up-portrait-lovely-young-african-american-woman-with-curly-afro-haircut-smiling-with-happy-pleasant-expression-enjoying-winter-holidays-wearing-sweater-blue-wall.jpg"
import Location from "../../../../API/tourisme/location/index"
import { toast, ToastContainer } from 'react-toastify';
import { Commentary } from '../../../../props';

function Commentaire({id,userId} : {id:any,userId:any}) {

    const [commentaire,setCommentaire] = useState("")
    var templateComment = {
        id:id,
        userId:userId,
        comment:commentaire
    }
    const [isShowMore, setIsShowMore] = useState(false);
    const [coms,setComs] = useState<Commentary[]>([]);

    const toggleReadMoreLess = () => {
        setIsShowMore(!isShowMore);
    };
    
    const getComment = ()=>{
        Location.getAllComment(id)
                .then((res:any)=>{
                    if(res.data.status === 200)
                    {
                        setComs(res.data.comments)
                    }
                }).catch((err:any)=>{
                    console.log("Erreur lors de l'appel a l'API ",err)
                })
    }
    const onSubmit = (event:any)=>{
       event.preventDefault()
        if(commentaire === '')
        {
        toast.error("Veuillez entrer votre commentaire")
        return;
        }
       Location.saveComment(templateComment)
                .then((res:any)=>{
                    if(res.data.status === 200)
                    {
                        setComs(res.data.comments)
                        toast.success("Commentaire enregistrer avec success");
                        setCommentaire("")
                    }
                }).catch((err:any)=>{
                    console.log("Erreur lors de l'appel a l'API ",err)
                })
    }

    useEffect(()=>{
       getComment();
    },[])

  return (
    <div>
        <ToastContainer/>
          <form onSubmit={onSubmit} className='flex md:flex-row s:flex-col s:space-y-4 md:space-y-0  md:space-x-4 xs:space-x-0'>
              <div className='border-2 rounded sm:w-[300px] s:w-[260px]   flex flex-row space-x-4 items-center '>
                  <RiMessage2Line className='text-[#8f8e8e] pl-2 text-2xl' />
                  <input type='text' name='commentaire'  placeholder='Ecrire un commentaire'
                      onChange={(e)=>setCommentaire(e.target.value)}
                      value={commentaire}
                      className='sm:w-[300px] s:w-[260px] border-0' />
              </div>
              <button className='bg-[#233D4D] w-[190px] h-10 text-white rounded hover:bg-white hover:text-[#233D4D] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-700'>Envoyer</button>
          </form>

          {isShowMore && (
              <div className='mt-10 flex flex-col space-y-5'>
                 {/* le commentaire 1 */}
                 {
                    coms.map((co,index)=>(
                        <div key={index} className='md:w-[500px] xs:w-[400px] s:w-[260px] sm:w-[300px]  bg-[#f7f7f7] p-4 rounded-lg'>
                            <div className='flex flex-row items-center space-x-4'>
                                {/* Photo de profil */}
                                <img src={co.Picture ? `data:image/png;base64,${co.Picture}` :  profil} className='rounded-full w-12 h-12' alt='profil_photo' />
                                {/* Nom d'utilisateure */}
                                <div className='text-[#4e4e4e] font-semibold'>
                                    {co.Names  ? co.Names : '' + ' ' + co.LastName ? co.LastName : '' } 
                                </div>
                            </div>
                            <div className='md:w-[478px] xs:w-[378px] s:w-[240px] sm:[280px] h-full'>
                                {co.comment}
                            </div>
                       </div>
                    ))
                 }
              </div>
          )}
          <button className='text-[#4e4e4e] flex flex-row space-x-5 items-center mt-5' onClick={toggleReadMoreLess}>
              {isShowMore ? "Voir moins" : "Voir les avis"}
              <IoIosArrowRoundForward className="text-lg " />
          </button>  
    </div>
  )
}

export default Commentaire